import { Button, Stack } from "@mui/material";
import { toast } from "react-toastify";
import { useFetch } from "src/hooks/useFetch.js";


const ToolbarAni = (props) => {
    const { fetch, loading } = useFetch();
    const clickHandler = (type, rows) => {
        fetch(`/telefonia/anis/${type}`, {
            method: 'POST',
            data: {
                did_ids: rows
            },
        }).then(() => {
            toast.success(
                'Se activaron los anis con éxito.',
            )
            props?.fetching()
        }).catch(e => {
            console.error(e)
            if (e?.statusCode >= 400 && e?.statusCode < 500) {
                toast.error(
                    e.message || 'Error, problemas con la información enviada',
                );
            } else {
                toast.error('Error, problemas de conexión con el servidor');
            }
        })
    }
    return (
        <>
            <Stack direction={"row"} spacing={2} alignItems={"center"} justifyContent={"flex-end"}>
                <Button
                    variant="contained"
                    color="success"
                    disabled={loading}
                    sx={{

                        backgroundColor: 'green',
                        color: 'white',
                        boxShadow: '0px 0px 0px 0px',
                    }}
                    onClick={() => clickHandler("enable", props.selectedRows)}

                >
                    Habilitar
                </Button>
                <Button
                    variant="contained"
                    color="error"
                    disabled={loading}
                    onClick={() => clickHandler("disable", props.selectedRows)}

                >
                    Deshabilitar
                </Button>
            </Stack>

        </>

    )
}
export default ToolbarAni;